import { Traveller, PaginationOptions, PaginatedResult } from '@/types';
import * as travellerRepository from '@/repository/travellerRepository';
import { Unsubscribe } from 'firebase/firestore';

export const travellerService = {
  // Existing methods - maintain backward compatibility
  listenToTravellers: (
    tripId: string, 
    callback: (travellers: Traveller[]) => void
  ): (() => void) => {
    return travellerRepository.listenToTravellers(tripId, callback);
  },

  listenToTravellersByApartment: (
    tripId: string, 
    apartmentId: string,
    callback: (travellers: Traveller[]) => void
  ): (() => void) => {
    const filters: travellerRepository.TravellerFilter[] = [['apartmentId', '==', apartmentId]];
    return travellerRepository.listenToTravellers(tripId, callback, filters);
  },

  // New paginated methods
  getTravellersPaginated: async (
    tripId: string,
    paginationOptions?: PaginationOptions
  ): Promise<PaginatedResult<Traveller>> => {
    return travellerRepository.getTravellersPaginated(tripId, paginationOptions);
  },

  listenToTravellersPaginated: (
    tripId: string,
    callback: (result: PaginatedResult<Traveller>) => void,
    paginationOptions?: PaginationOptions
  ): Unsubscribe => {
    return travellerRepository.listenToTravellersPaginated(tripId, callback, paginationOptions);
  },

  getTravellersByApartmentPaginated: async (
    tripId: string,
    apartmentId: string,
    paginationOptions?: PaginationOptions
  ): Promise<PaginatedResult<Traveller>> => {
    const filters: travellerRepository.TravellerFilter[] = [['apartmentId', '==', apartmentId]];
    return travellerRepository.getTravellersPaginated(tripId, paginationOptions, filters);
  },

  listenToTravellersByApartmentPaginated: (
    tripId: string,
    apartmentId: string,
    callback: (result: PaginatedResult<Traveller>) => void,
    paginationOptions?: PaginationOptions
  ): Unsubscribe => {
    const filters: travellerRepository.TravellerFilter[] = [['apartmentId', '==', apartmentId]];
    return travellerRepository.listenToTravellersPaginated(tripId, callback, paginationOptions, filters);
  },

  // CRUD operations remain unchanged
  addTraveller: (
    tripId: string, 
    traveller: Omit<Traveller, 'id'>
  ): Promise<string> => {
    return travellerRepository.addTraveller(tripId, traveller);
  },

  updateTraveller: (
    tripId: string, 
    travellerId: string,
    data: Partial<Traveller>
  ): Promise<void> => {
    return travellerRepository.updateTraveller(tripId, travellerId, data);
  },

  deleteTraveller: (
    tripId: string, 
    travellerId: string
  ): Promise<void> => {
    return travellerRepository.deleteTraveller(tripId, travellerId);
  },
};
